import React from "react";
import { cn } from "@/lib/utils";
import { BadgeCheck } from "lucide-react";

/**
 * "Verified PooPlucker" pill badge. Orange background, white text, tiny mark
 * on the left. Component identifier intentionally kept as `CertifiedBadge`
 * so the JSX usage sites don't need to change — only the user-facing label
 * string was downgraded from "Certified" until a real certification flow
 * exists.
 */
export default function CertifiedBadge({ className = "", label = "Verified PooPlucker" }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full bg-brand-orange px-3 py-1 text-xs font-bold uppercase tracking-wider text-white shadow-sm",
        className
      )}
      data-testid="certified-pooplucker-badge"
    >
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white p-0.5">
        <img
          src="/brand/pooppluckers-mark.png"
          alt=""
          aria-hidden="true"
          className="h-full w-full object-contain"
          draggable={false}
        />
      </span>
      <BadgeCheck className="h-3.5 w-3.5" />
      <span>{label}</span>
    </span>
  );
}
